import * as React from 'react';
import { flushSync } from 'react-dom';
import { useObservable } from '@avensia/observable';
import { currentPage, isLoading, type PageBase, type PageOrError } from './state';
import { getRequestContext } from '../server/request-context';

export function useIsLoading() {
  return useObservable(isLoading);
}

export function useCurrentPage() {
  return React.useContext(currentPageContext);
}

const currentPageContext = React.createContext<PageOrError>(undefined as any);

function initialPage() {
  return __BROWSER__ ? window.INITIAL_DATA.page : getRequestContext().initialData.clientData.page;
}

export function CurrentPageProvider(props: React.PropsWithChildren<{}>) {
  if (currentPage.currentSync() === undefined) {
    currentPage.emit(initialPage());
  }
  const [pageState, setPageState] = React.useState<PageOrError>(initialPage());
  if (__BROWSER__) {
    currentPage.on(data => {
      flushSync(() => {
        setPageState(data);
      });
    });
  }
  return <currentPageContext.Provider value={pageState}>{props.children}</currentPageContext.Provider>;
}
